import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-base-toggle-switch',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './base-toggle-switch.component.html',
  styleUrl: './base-toggle-switch.component.scss'
})
export class BaseToggleSwitchComponent {
  @Input() checked: boolean = false;
  @Input() disabled: boolean = false;
  @Output() toggled = new EventEmitter<boolean>();

  onToggle() {
    this.checked = !this.checked;
    this.toggled.emit(this.checked);
  }
}
